import React from "react";
import ShowCounter from "./Showcounter";

const CountdownContainer = ({ translation, countdownNumbers }) => {
    const [days, hours, minutes, seconds] = countdownNumbers;

    if (days + hours + minutes + seconds < 0) {
      return ''
    } else {
      return (
        <ShowCounter
          days={days}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
          translation={translation}
        />
      );
    }
}

export default CountdownContainer